import React from "react";
import shortid from 'shortid';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { hasIframeTag } from '@dmi-mch/utils';

var generateIframeCode = function generateIframeCode(trackUrl) {
  return "<iframe\n    width=\"100%\"\n    height=\"20\"\n    scrolling=\"no\"\n    frameborder=\"no\"\n    allow=\"autoplay\"\n    title=\"SoundCloud Audio Player\"\n    src=\"https://w.soundcloud.com/player/?url&#61;".concat(trackUrl, "&amp;color&#61;%23e0004d&amp;auto_play&#61;false&amp;hide_related&#61;true&amp;show_comments&#61;false&amp;show_user&#61;true&amp;show_reposts&#61;false&amp;show_teaser&#61;false\"\n  />");
};

var IframeComponent = function IframeComponent(_ref) {
  var trackUrl = _ref.trackUrl;
  return /*#__PURE__*/React.createElement(StyledAudioGuide, null, /*#__PURE__*/React.createElement("div", {
    className: "audio-guide" // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: generateIframeCode(trackUrl)
    }
  }));
};

IframeComponent.propTypes = {
  trackUrl: PropTypes.string
};

var AudioGuide = function AudioGuide(_ref2) {
  var content = _ref2.content;

  if (!content) {
    return null;
  }

  if (content) {
    if (hasIframeTag(content)) {
      return /*#__PURE__*/React.createElement("div", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
          __html: content
        }
      });
    }

    var tracks = content ? content.split(',') : null;

    if (tracks.length === 0) {
      return null;
    } else if (tracks.length === 1) {
      return /*#__PURE__*/React.createElement(IframeComponent, {
        trackUrl: tracks[0]
      });
    }

    return tracks.map(function (url) {
      return /*#__PURE__*/React.createElement(IframeComponent, {
        trackUrl: url,
        key: shortid.generate()
      });
    });
  }

  return null;
};

AudioGuide.propTypes = {
  content: PropTypes.string,
  className: PropTypes.string
};
var StyledAudioGuide = styled.div.withConfig({
  displayName: "AudioGuide__StyledAudioGuide",
  componentId: "sc-n705y5-0"
})([".audio-guide{display:flex;flex-direction:column;height:40px;background:#f0f0f0;justify-content:center;align-items:center;margin-bottom:16px !important;padding:0 7px;&:last-of-type{margin-bottom:0;}}"]);
export default AudioGuide;